'use client';

import React from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';

interface HeroWrapperProps {
  children: React.ReactNode;
  alignment?: 'left' | 'center' | 'right';
  backgroundImage?: string;
}

const HeroWrapper: React.FC<HeroWrapperProps> = ({
  children,
  alignment = 'left',
  backgroundImage,
}) => {
  const isRightAlign = alignment === 'right';

  return (
    <div className="overflow-hidden relative h-[600px] md:h-[750px]">
      {/* Background sliding image */}
      <div
        className={classNames(
          'bg-black text-white py-[220px] h-full relative w-[5760px] bg-auto bg-repeat-x',
          'animate-[slide_45s_linear_infinite]',
          isRightAlign ? 'right-0' : 'left-0',
        )}
        style={{
          backgroundImage: backgroundImage
            ? `url('${backgroundImage}')`
            : "url('/assets/images/why/why-banner.png')",
          backgroundSize: 'auto 100%',
          animationName: isRightAlign ? 'slideRight' : 'slide',
        }}
      />

      {/* Content overlay */}
      <div className="absolute w-full h-full top-0 left-0 z-[99] text-white px-4 md:px-10 flex items-center">
        {/* Black overlay gradient */}
        <div
          className={classNames(
            'absolute block w-full h-full top-0 z-[-1]',
            isRightAlign
              ? 'right-0 bg-gradient-to-l from-black via-black/80 to-transparent'
              : 'left-0 bg-gradient-to-r from-black via-black/80 to-transparent',
          )}
        />

        {/* Content container */}
        <div className={classNames('site-container', isRightAlign ? 'text-right' : 'text-left')}>
          <div
            className={classNames(
              'relative z-[99]',
              isRightAlign ? 'w-[735px] ml-auto xl:mr-[-200px]' : 'lg:w-[735px] xl:ml-[-200px]',
            )}
            aria-live="polite"
          >
            {children}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide {
          0% {
            transform: translate3d(0, 0, 0);
          }
          100% {
            transform: translate3d(-1920px, 0, 0);
          }
        }
        @keyframes slideRight {
          0% {
            transform: translate3d(-1920px, 0, 0);
          }
          100% {
            transform: translate3d(0, 0, 0);
          }
        }
      `}</style>
    </div>
  );
};

export default HeroWrapper;
